.root {
    position: sticky;
    bottom: 0;
}
